<!-- <button (click)="loginWithFacebook()"> loginWithFacebook </button>
<button (click)="signInWithFB()"> signInWithFB </button> -->

<div class="custom-alert-wrapper">
    <!-- <ng-container *ngIf="sharedService.alerts$ | async as alerts">
        <ng-container *ngFor="let alert of alerts">
            <div class="custom-alert" *ngIf="!hiddenAlertIds.has(alert.id)">
                <nz-alert [nzType]="alert.type" [nzMessage]="alert.message" nzShowIcon [nzCloseable]="false"
                    [nzAction]="alert.action ? actionTemplateMap[alert.action] : null" class="mb-2"></nz-alert>

                <svg class="close-btn" (click)="hideAlert(alert.id)" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24" width="16" height="16" color="#000000" fill="none">
                    <path
                        d="M12 21.5H12H12C16.4783 21.5 18.7175 21.5 20.1088 20.1088C21.5 18.7175 21.5 16.4783 21.5 12V12V12C21.5 7.52165 21.5 5.28248 20.1088 3.89124C18.7175 2.5 16.4783 2.5 12 2.5C7.52166 2.5 5.28249 2.5 3.89124 3.89124C2.5 5.28249 2.5 7.52166 2.5 12C2.5 16.4783 2.5 18.7175 3.89124 20.1088C5.28248 21.5 7.52165 21.5 12 21.5Z"
                        stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M15 9L9 14.9996M15 15L9 9.00039" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                </svg>
            </div>
        </ng-container>
    </ng-container> -->


    <!-- Action Templates
    <ng-template #subscriptionTemplate>
        <button nz-button class="btn btn-danger " (click)="goToSubscription()">Subscribe Now</button>
    </ng-template>

    <ng-template #verifyTemplate>
        <button nz-button class="btn btn-warning " (click)="openVerificationModal()">Verify Now</button>
    </ng-template> -->
</div>

@if (!isIframe) {
<div [@routeAnimations]="getRouteAnimationData(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</div>
<app-loader></app-loader>
}